import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { Store } from "@ngrx/store";
import { Subject, Subscription, takeUntil } from "rxjs";
import { ViewPageActions } from "../../../transaction-view/actions";
import { hideEditingRestrictedModal } from "../../actions/shared.actions";
import { selectShowEditingRestrictedModal } from "../../reducers";

@Component({
  standalone: false,
  selector: 'mm-editing-restricted-modal',
  templateUrl: './editing-restricted-modal.component.html',
  styleUrls: ['./editing-restricted-modal.component.scss']
})

export class EditingRestrictedModalComponent implements OnInit, OnDestroy {
  modal: EverestModal;
  destroy$: Subject<boolean> = new Subject<boolean>();
  showModalSub: Subscription;
  title = 'This transaction cannot be edited';
  textBody = 'Once a transaction has been submitted to your client for eAuthorization, the details cannot be edited. If changes are required, please cancel the original transaction immediately, and then create and submit a new one.';
  constructor(private store: Store) {}

  ngOnInit(): void {
    this.store.select(selectShowEditingRestrictedModal).pipe(takeUntil(this.destroy$)).subscribe((show) => {
      this.modal = document.getElementById('editing-restricted-modal') as EverestModal;
      if (show) this.modal.showModal();
    })
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  onOkayClick(): void {
    this.modal.hideModal();
  }

  onModalClose(event: any) {
    this.store.dispatch(hideEditingRestrictedModal());
  }
}

type EverestModal = HTMLElement & {
  showModal: () => {};
  hideModal: () => {};
};